export enum MemberStatus {
  Active = "active",
  Inactive = "inactive",
  Pending = "pending",
  Ghost = "ghost",
  Supervisor = "supervisor",
  Moderator = "moderator",
  Banned = "banned"
}

export type Member = {
  id: string;
  name: string;
  fullName?: string;
  picture: string;
  intro?: string;
  memberId: string;
  memberStatus: MemberStatus;
};

export enum MemberStatusColor {
  Green = 'green',
  Yellow = 'yellow',
  Red = 'red',
  Gray = 'gray',
}
